import { useMemo } from 'react';

import { Edition, Product, ProductKey, products } from './products';

export const useProductIntent = () =>
	// eslint-disable-next-line complexity
	useMemo(() => {
		let edition: Edition | undefined;
		let product: Product | undefined;

		if (typeof window === 'undefined') {
			return { edition, product };
		}

		const params = new URLSearchParams(window.location.search);

		if (window.location.pathname.includes('/software/jira/product-discovery')) {
			product = {
				bundle: 'jira-product-discovery',
				description: 'Jira Product Discovery',
				key: ProductKey.JIRA_PRODUCT_DISCOVERY,
				name: 'jira-product-discovery',
			};
			edition = 'free';
		} else if (window.location.pathname.includes('/software/jira/service-management')) {
			product = {
				bundle: 'jira-service-management',
				description: 'Jira Service Management',
				key: ProductKey.JIRA_SERVICE_MANAGEMENT,
				name: 'jira-servicedesk',
			};
			edition = 'free';
		} else if (window.location.pathname.includes('/software/jira')) {
			product = {
				bundle: 'jira-software',
				description: 'Jira',
				key: ProductKey.JIRA_SOFTWARE,
				name: 'jira',
			};
			edition = 'free';
		}

		if (window.location.pathname.includes('/software/confluence')) {
			product = {
				bundle: 'confluence',
				description: 'Confluence',
				key: ProductKey.CONFLUENCE,
				name: 'confluence',
			};
			edition = 'free';
		}

		const isSignupPage = window.location.pathname.endsWith('/try/cloud/signup');

		const isConfirmationPage = window.location.pathname.endsWith('/ondemand/signup/confirmation');

		if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
			// defaults for the signup page
			if (isSignupPage) {
				edition = 'free';
				product = {
					bundle: 'jira-software',
					description: 'Jira',
					key: ProductKey.JIRA_SOFTWARE,
					name: 'jira',
				};
			}

			// determine product
			if (params.has('product')) {
				product = products.find((product) => product.key === params.get('product'));
			} else if (params.has('bundle')) {
				product = products.find((product) => product.bundle === params.get('bundle'));
			} else if (params.has('products')) {
				product = products.find((product) => product.key === params.get('products')?.split(',')[0]);
			}

			// determine edition
			const editionParam = params.get('edition');
			if (editionParam === 'free') {
				edition = 'free';
			} else if (editionParam === 'standard') {
				edition = 'standard';
			} else if (editionParam === 'premium') {
				edition = 'premium';
			}
		}

		return { edition, product };
	}, []);
